// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetMetadata} from './asset-metadata.js'

export class RecordingAsset {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): RecordingAsset {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsRecordingAsset(bb: flatbuffers.ByteBuffer, obj?: RecordingAsset): RecordingAsset {
    return (obj || new RecordingAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsRecordingAsset(bb: flatbuffers.ByteBuffer, obj?: RecordingAsset): RecordingAsset {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new RecordingAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  metadata(obj?: AssetMetadata): AssetMetadata | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetMetadata()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startRecordingAsset(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addMetadata(builder: flatbuffers.Builder, metadataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metadataOffset, 0)
  }

  static endRecordingAsset(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // metadata
    return offset
  }

  static createRecordingAsset(builder: flatbuffers.Builder, metadataOffset: flatbuffers.Offset): flatbuffers.Offset {
    RecordingAsset.startRecordingAsset(builder)
    RecordingAsset.addMetadata(builder, metadataOffset)
    return RecordingAsset.endRecordingAsset(builder)
  }
}
